import React, { useState } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'

import Header from './components/general/Header'
import Footer from './components/general/Footer'

const GeneralPath = () => {
	const location = useLocation()

	return (
		<>
			<Header loc={location.pathname} />
			<div>
				<Outlet />
			</div>
			<Footer />
		</>
	)
}

export default GeneralPath
